<template>
  <Header style="position: fixed; width:100%; background: transparent; border:none;">
    <div class="container" style="margin-top:12px;">
      <!--
      <div class="navbar-brand" style>
        <router-link :to="'/'+$router.currentRoute.params.shortLink+'/landing'">
          <img :src="logoUrl" alt="logo" v-if="pageSettings.logoUrl" />
        </router-link>
			
      </div>
      -->
      <Button style="float:right;" @click="logoutClick()" v-if="hasReg">Logout</Button>
    </div>
  </Header>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },

  computed: {
    ...mapGetters("registrations", {
      registration: "getCopy"
    }),
    ...mapGetters("page-settings", {
      getPageSettings: "find"
    }),
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),

    hasReg() {
      return this.registration ? true : false;
    },

    pageSettings() {
      return this.getPageSettings({ query: {} }).data[0];
    },

    logoUrl() {
      let pageSettings = this.pageSettings;
      return pageSettings && pageSettings.logoUrl ? pageSettings.logoUrl : "";
    },
    isLanding() {
      console.log(this.$router.currentRoute.name);
      if (this.$router.currentRoute.name == "landing") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions("registrations", {
      logout: "logout"
    }),
    logoutClick() {
      this.logout(this.webcast._id);
      this.$router.replace("/" + this.webcast.shortLink + "/landing");
    }
  },
  created() {}
};
</script>

<style lang="scss">
</style>
